import {getFallbackGameImage} from "@assets/images/fallbackGameImage";
import {useQuery} from "@tanstack/react-query";
import {useAuthStore} from "@/store/useAuth.store";
import {useGameMetadataStore} from "@/store/useGameMetadataStore";
import {recentGamesService} from "../../services/games/gamesList/recentGames.service";
import {isVisibleGame} from "../../util/hiddenGames";

export const useGetRecentGames = () => {
  const authStatus = useAuthStore(state => state.authStatus);
  const isAuthenticated = authStatus === "authenticated";
  const getGameById = useGameMetadataStore(state => state.getGameById);

  const {data, isPending, error} = useQuery({
    queryKey: ["recentGames"],
    queryFn: () => recentGamesService(),
    staleTime: 1000 * 60 * 5,
    enabled: isAuthenticated,
    select: responseData => {
      const gamesList = responseData?.data?.data || [];
      return gamesList.filter(isVisibleGame).map((recentGame, index) => {
        const game = getGameById(recentGame.game_id, recentGame.game_provider);
        return {
          ...recentGame,
          icon: game?.icon || getFallbackGameImage(),
          provider: game?.provider || recentGame.game_provider,
          provider_display_name: game?.provider_display_name || recentGame.provider_display_name || "",
          name: game?.name || recentGame.game_name || "Unknown Game",
          id: game?.id || recentGame.game_id,
          uniqueId: `${recentGame.game_id || "game"}-${recentGame.game_provider || "provider"}-${index}`,
        };
      });
    },
  });

  return {
    recentGames: data || [],
    isPending,
    error,
  };
};
